"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.firebaseWeb = void 0;
exports.firebaseWeb = {
    apiKey: "AIzaSyDQGLU-ni3Re07REfqIcauIwG2xCK1P3r0",
    authDomain: "rsonav-1da8e.firebaseapp.com",
    databaseURL: "https://rsonav-1da8e.firebaseio.com",
    projectId: "rsonav-1da8e",
    storageBucket: "rsonav-1da8e.appspot.com",
    messagingSenderId: "968392220784",
    appId: "1:968392220784:web:7a91dc336d163c814154b5",
    measurementId: "G-RNTFB7YLQ2",
};
//# sourceMappingURL=firebaseWeb.js.map